import React from 'react';
import {Button, Modal} from 'react-bootstrap';
import ContactForm from '../contacts/ContactForm';
import validator from 'validator';
import PropTypes from 'prop-types';

class CreateContactModal extends React.Component {

  constructor(props) {
    super(props);

    this.initialState = {
      errors: {},
      error: null,
      contact: {
        first_name: '',
        last_name: '',
        email: '',
        phone: ''
      }
    };

    this.state = this.initialState;

    this.onExiting = this.onExiting.bind(this);
    this.validate = this.validate.bind(this);
    this.updateContactState = this.updateContactState.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  onSave() {
    if(this.validate(this.state)) {
      this.props.onSave(this.state.contact);
    }
  }

  onExiting() {
    this.setState(this.initialState);
  }

  validate() {
    const requiredFields = ['first_name', 'last_name', 'email'];
    let errors = {};
    
    if(!validator.isEmail(this.state.contact['email'])) {
      errors['email'] = 'This must be an email.';
    }

    if (this.state.contact['phone'] && !validator.isMobilePhone(this.state.contact.phone, 'en-US')) {
      errors['phone'] = 'This must be a phone number (no dashes).';
    }

    requiredFields.forEach(f => {
      if (validator.isEmpty(this.state.contact[f])) {
        errors[f] = 'This is a required field.';
      }
    });

    this.setState({errors: errors});
    return Object.keys(errors).length === 0;
  }

  updateContactState(event) {
    let errors = this.state.errors;
    const field = event.target.name;
    errors[field] = null;
    let state = { errors, contact: this.state.contact };
    state.contact[field] = event.target.value;
    return this.setState(state);
  }

  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.handleClose}
        onExiting={this.onExiting}>
        <Modal.Header closebutton="true">
          <Modal.Title>Create Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ContactForm
            errors={this.state.errors}
            onChange={this.updateContactState}
            preset={this.state.contact}/>
        </Modal.Body>
        <Modal.Footer>
          <Button data-cy="select-teams-button" onClick={this.onSave}>Create Contact</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

CreateContactModal.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  onSave: PropTypes.func
};

export default CreateContactModal;


// WEBPACK FOOTER //
// ./src/components/teams/CreateContactModal.js